module.exports = __webpack_public_path__ + "static/img/amazon.6b8baf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/amazon.png
// module id = 29lH
// module chunks = 1